import { AxiosError } from 'axios';
import { getLogisticServiceDetailsById, uploadDocumentLogisticsService } from '../../../services/services';
import { IUploadLogisticServiceFile, IlogisticServiceDetails } from '../../../types/services';
import errorMessage from '../../../utils/errorMessage';
import { errorTextOnlyPdf, isFileValid, validFormatsForDocumentsOnlyPdf } from '../../../utils/validateFiles';
import { displaySuccessNotification } from '../../../utils/displayNudosStandardNotifications';
import { getLogisticServiceHistory } from '../../../services/suscription/history.service';
import { ILogisticServiceHistory } from '../../../types/suscription/history.types';

export const getLogisticServiceDetails = async (
  logisticServiceId: string | number,
  dataHandler: (data: IlogisticServiceDetails) => void,
  loaderHandler?: (isLoading: boolean) => void,
  customErrorHandler?: (error: AxiosError) => void
) => {
  if (!logisticServiceId) return;
  loaderHandler && loaderHandler(true);
  try {
    const response = await getLogisticServiceDetailsById(logisticServiceId);
    dataHandler(response);
  } catch (error) {
    if (customErrorHandler) return customErrorHandler(error as AxiosError);
    errorMessage();
  } finally {
    loaderHandler && loaderHandler(false);
  }
};

export const retrieveLogisticServiceHistory = async (
  logisticServiceId: string | number,
  dataHandler: (data: ILogisticServiceHistory[]) => void,
  setCombinedHistoryData: React.Dispatch<React.SetStateAction<boolean>>,
  loaderHandler?: (isLoading: boolean) => void,
  customErrorHandler?: (error: AxiosError) => void
) => {
  if (!logisticServiceId) return;
  loaderHandler && loaderHandler(true);
  try {
    const response = await getLogisticServiceHistory(Number(logisticServiceId));
    dataHandler(response);
    setCombinedHistoryData(true);
  } catch (error) {
    if (customErrorHandler) return customErrorHandler(error as AxiosError);
    errorMessage();
  } finally {
    loaderHandler && loaderHandler(false);
  }
};

export const uploadLogisticServiceFile = async ({
  logisticServiceId,
  type,
  file,
  handleLoading,
  updateDataCallback,
  billingCountryId,
  customSuccessMessage
}: IUploadLogisticServiceFile) => {
  if (!logisticServiceId || !type || !file) return;
  const validFile = isFileValid(
    file,
    validFormatsForDocumentsOnlyPdf,
    10,
    errorTextOnlyPdf,
    'El documento no debe superar los 10MB'
  );
  if (!validFile) return;
  handleLoading && handleLoading(true);
  try {
    await uploadDocumentLogisticsService(logisticServiceId, type, file, billingCountryId);
    updateDataCallback && updateDataCallback();
    customSuccessMessage && displaySuccessNotification({ customJSXMessage: <>{customSuccessMessage}</> });
  } catch {
    errorMessage();
  } finally {
    handleLoading && handleLoading(false);
  }
};
